var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCornersIn = function SvgIconCornersIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4.5a1 1 0 1 0-2 0V9a1 1 0 0 0 1 1h4.5a1 1 0 1 0 0-2H16zM4.5 14a1 1 0 1 0 0 2H8v3.5a1 1 0 1 0 2 0V15a1 1 0 0 0-1-1zM14 15a1 1 0 0 1 1-1h4.5a1 1 0 1 1 0 2H16v3.5a1 1 0 1 1-2 0zM10 4.5a1 1 0 0 0-2 0V8H4.5a1 1 0 0 0 0 2H9a1 1 0 0 0 1-1z"
  }))));
};
export default SvgIconCornersIn;